var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-submenu',{ref:"subMenu",attrs:{"index":_vm.handlePath(_vm.item.path),"popper-append-to-body":false}},[_c('template',{slot:"title"},[_c('i',{class:_vm.item.meta.icon,staticStyle:{"color":"#fff"}}),_c('span',[_vm._v(_vm._s(_vm.item.meta.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }